import { useSplitClient as useSplitClientNative } from '@splitsoftware/splitio-react';
import { useMemo } from 'react';

export function useSplitClient(splitKey: string | undefined) {
  const { client, isReady, isTimedout } = useSplitClientNative({
    splitKey,
    updateOnSdkUpdate: true,
    updateOnSdkTimedout: true,
    updateOnSdkReady: true,
  });

  return useMemo(() => {
    if (!splitKey) {
      return { client: null, isReady: false };
    }

    return { client, isReady: isReady || isTimedout };
  }, [splitKey, client, isReady, isTimedout]);
}
